module.exports = __webpack_public_path__ + "img/Pandya.580fe583.jpg";